import React from "react";
import Typed from "react-typed";
import { Player } from "video-react";
import "../../../../node_modules/video-react/dist/video-react.css";
import { Fade } from "react-reveal";

import "./LayoutProjects.css";

export default function LayoutProjects({
  title,
  features,
  img,
  description,
  video,
  tecno,
  color,
  textColor,
  link,
}) {
  let language = localStorage.getItem("language");

  return (
    <div className="layout-projects">
      <Fade>
        <h1 className="layout-projects__title">{title}</h1>
      </Fade>
      <Fade left>
        <div
          className="layout-projects__features"
          style={{ backgroundColor: color, color: textColor }}
        >
          <h2>{language === "english" ? "Features" : "Caracteristicas"}</h2>
          <Typed strings={features} loop typeSpeed={40} backSpeed={50} />
        </div>
      </Fade>
      <Fade top cascade>
        <img src={img} alt={title} className="layout-projects__img" />
        <p className="layout-projects__description">{description}</p>
      </Fade>

      <Fade right>
        <div className="layout-projects__video">
          <Player playsInline poster={img} src={video} fluid />
        </div>
      </Fade>
      <div className="layout-projects__list">
        <p>
          {language === "english"
            ? "Tecnologies and languages used in this project:"
            : "Tecnologías y lenguajes usados en este proyecto:"}
        </p>
        <Fade cascade top>
          <ul>
            {tecno.map((tec, i) => {
              return <li key={i}>{tec}</li>;
            })}
          </ul>
        </Fade>
      </div>
      <p className="layout-projects__link">
        <a href={link} target="_blank" rel="noreferrer">
          {language === "english"
            ? `Link to the page or project`
            : `Ir a la página o proyecto.`}
        </a>
      </p>
    </div>
  );
}
